import { Container, Row, Col, Tab, Tabs, Card, Button } from "react-bootstrap";
import ContentImage from "../component/ContentImage";
import { useEffect } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import Reveal from "../component/Reveal";
import HeroBanner from "../component/HeroBanner";
import ImageKit from "../component/ImageKit";
import CommunityDevelopmentProjects from "../static/ProjectsData/CommunityDevelopment";
import InternationalCooperationProjects from "../static/ProjectsData/InternationalCooperation";
import BusinessAndEnterpreneurshipProjects from "../static/ProjectsData/BusinessAndEnterpreneurship";
import IndividualDevelopmentProjects from "../static/ProjectsData/IndividualDevelopment";


const Projects = () => {
  const navigate = useNavigate();
  useEffect(()=>{
    document.title = "JCI Lucena - Projects"
  }, [])

  const AllProjects = [
    ...CommunityDevelopmentProjects,
    ...InternationalCooperationProjects,
    ...IndividualDevelopmentProjects,
    ...BusinessAndEnterpreneurshipProjects,
  ];

  return (
    <div>
      <div className="hero-banner-div">
        <HeroBanner
          className="hero-banner"
          src={'https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-1200,f-auto,q-80 1920w'}
          srcSet={`
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-400,q-60 400w,
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-800,q-60 800w,
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-1200,q-60 1200w,
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-1920,q-70 1920w,
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-2560,q-80 2560w,
            https://ik.imagekit.io/wwg4nuz3a/projects/projects-hero-banner.jpg?tr=w-3840,q-80 3840w
          `}
          // src={'post-placeholder.png'}
          sizes="100vw"
        />
      </div>
      <Container className='projects-container'>
        <Row>
          <Col>
            <Reveal delay={0.2}>
              <div className="left-projects-div">
                <img
                  src="https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-1200,f-auto,q-80 1200w"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-400,h-500,fo-auto,q-70 400w,
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-800,h-500,fo-auto,q-70 800w,
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-1200,h-670,fo-auto,q-70 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-1920,h-970,fo-auto,q-80 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-2560,fo-auto,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/projects/projects-img.jpg?tr=w-3840,fo-auto,q-80 3840w
                  "
                sizes="
                  (max-width: 640px) 390px,
                  (max-width: 1024px) 50vw, 30vw
                "
                />
                <div className="left-projects-header-paragraph-div">
                  <h1><b>Projects</b></h1>
                  <p>
                    At JCI Lucena, we believe that lasting change starts with active citizens. Our projects are the heartbeat of our Local Organization, driven by young leaders who step up to solve challenges, create sustainable impact and positive change. Guided by the JCI Plan of Action, our initiatives fall into four core pillars of opportunity.
                  </p>
                </div>
              </div>
              <Tabs
                defaultActiveKey="Current"
                id="uncontrolled-tab-example"
                className="project-tabs mb-3"
              > 
              <Tab eventKey="Current" title="All Projects">
                <div className="projects-grid">
                  {AllProjects.map((project) => (
                    <Card className="projects-card">
                      <ImageKit 
                        path={project.thumbnail}
                        // ratio={imgPath.aspect}
                        alt={project.title}
                        // className="project-image-main-frame"
                        // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                      />
                      <Card.Body>
                        <Card.Title><h4>{project.title}</h4></Card.Title>
                        <Card.Text>
                          {project.description}
                        </Card.Text>
                        <div className="home-projects-preview-card-button">
                          <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/${project.division}/${project.id}`);}}>View</Button>
                          {/* maybe mas okay gawin clickable link images */}
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                  </div>
                  {/* might need to use next.js for slug files */}
                </Tab>
                <Tab eventKey="first" title="Community Development">
                  <div className="projects-grid">
                    {CommunityDevelopmentProjects.map((project) => (
                      <Card className="projects-card">
                        <ImageKit 
                          path={project.thumbnail}
                          // ratio={imgPath.aspect}
                          alt={project.title}
                          // className="project-image-main-frame"
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                        />
                        <Card.Body>
                          <Card.Title><h4>{project.title}</h4></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/community-development/${project.id}`);}}>View</Button>
                            {/* maybe mas okay gawin clickable link images */}
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                  {/* might need to use next.js for slug files */}
                </Tab>
                <Tab eventKey="second" title="Business & Entrepreneurship">
                  <div className="projects-grid">
                    {BusinessAndEnterpreneurshipProjects.map((project) => (
                      <Card className="projects-card">
                        <ImageKit 
                          path={project.thumbnail}
                          // ratio={imgPath.aspect}
                          alt={project.title}
                          // className="project-image-main-frame"
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                        />
                        <Card.Body>
                          <Card.Title><h4>{project.title}</h4></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/business-and-entrepreneurship/${project.id}`);}}>View</Button>
                            {/* maybe mas okay gawin clickable link images */}
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </Tab>
                <Tab eventKey="third" title="Individual Development">
                  <div className="projects-grid">
                    {IndividualDevelopmentProjects.map((project) => (
                      <Card className="projects-card">
                        <ImageKit 
                          path={project.thumbnail}
                          // ratio={imgPath.aspect}
                          alt={project.title}
                          // className="project-image-main-frame"
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                        />
                        <Card.Body>
                          <Card.Title><h4>{project.title}</h4></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/individual-development/${project.id}`);}}>View</Button>
                            {/* maybe mas okay gawin clickable link images */}
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </Tab>
                <Tab eventKey="fourth" title="International Cooperation">
                  <div className="projects-grid">
                    {InternationalCooperationProjects.map((project) => (
                      <Card className="projects-card">
                        <ImageKit 
                          path={project.thumbnail}
                          // ratio={imgPath.aspect}
                          alt={project.title}
                          // className="project-image-main-frame"
                          // ratio="16/9" // You can change this to "4/5" for mobile-first tall images
                        />
                        <Card.Body>
                          <Card.Title><h4>{project.title}</h4></Card.Title>
                          <Card.Text>
                            {project.description}
                          </Card.Text>
                          <div className="home-projects-preview-card-button">
                            <Button variant="primary" onClick={(e) => {e.stopPropagation(); navigate(`/projects/international-cooperation/${project.id}`);}}>View</Button>
                            {/* maybe mas okay gawin clickable link images */}
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </Tab>
                {/* <Tab eventKey="2020" title="2020">
                  Tab content for 2022. This tab is under construction
                </Tab> */}
              </Tabs>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Projects;